import { HIDE_LOADER, INIT_LOADER_HIDING, INIT_LOADER_SHOWING, INIT_REQUEST_COUNTER_DECREASING, INIT_REQUEST_COUNTER_INCREASING, LOADER_SHOW, REQUEST_COUNTER_DECREASE, REQUEST_COUNTER_INCREASE } from '@store/loader/loader.action-types';
export var actions = {
  /**
   * Init loader showing.
   *
   * @author Mikhail Siutsou
   * @function initModalShowing
   * @category Actions
   */
  initLoaderShowing: function initLoaderShowing() {
    return {
      type: INIT_LOADER_SHOWING
    };
  },

  /**
   * Show loader.
   *
   * @author Mikhail Siutsou
   * @function showLoader
   * @category Actions
   * @subcategory Loader
   */
  showLoader: function showLoader() {
    return {
      type: LOADER_SHOW
    };
  },

  /**
   * Init loader hiding.
   *
   * @author Mikhail Siutsou
   * @function initLoaderHiding
   * @category Actions
   * @subcategory Loader
   */
  initLoaderHiding: function initLoaderHiding() {
    return {
      type: INIT_LOADER_HIDING
    };
  },

  /**
   * Hide loader.
   *
   * @author Mikhail Siutsou
   * @function hideLoader
   * @category Actions
   * @subcategory Loader
   */
  hideLoader: function hideLoader() {
    return {
      type: HIDE_LOADER
    };
  },

  /**
   * Init increasing of request counter.
   *
   * @author Mikhail Siutsou
   * @function initIncreasingRequestCounter
   * @category Actions
   * @subcategory Loader
   */
  initIncreasingRequestCounter: function initIncreasingRequestCounter() {
    return {
      type: INIT_REQUEST_COUNTER_INCREASING
    };
  },

  /**
   * Increase request counter.
   *
   * @author Mikhail Siutsou
   * @function increaseRequestCounter
   * @category Actions
   * @subcategory Loader
   */
  increaseRequestCounter: function increaseRequestCounter() {
    return {
      type: REQUEST_COUNTER_INCREASE
    };
  },

  /**
   * Init decreasing of request counter..
   *
   * @author Mikhail Siutsou
   * @function initDecreasingRequestCounter
   * @category Actions
   * @subcategory Loader
   */
  initDecreasingRequestCounter: function initDecreasingRequestCounter() {
    return {
      type: INIT_REQUEST_COUNTER_DECREASING
    };
  },

  /**
   * Decrease request counter.
   *
   * @author Mikhail Siutsou
   * @function decreaseRequestCounter
   * @category Actions
   * @subcategory Loader
   */
  decreaseRequestCounter: function decreaseRequestCounter() {
    return {
      type: REQUEST_COUNTER_DECREASE
    };
  }
};